import React          from 'react';
import {useNavigate } from "react-router-dom";
import Card           from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent    from '@material-ui/core/CardContent';
import CardMedia      from '@material-ui/core/CardMedia';
import Typography     from '@material-ui/core/Typography'
import 'firebase/compat/storage';

/**
 * MemberData
 * 家族メンバーのカード。クリックで`PersonalHome`、編集で`FamilyRegist`へ遷移。
 * @param {object} props プロパティ
 * @param {string} props.memberName 表示名
 * @param {string} props.member_url メンバー画像URL
 * @param {string} props.memberID メンバーID
 * @param {string} props.familyID 家族ID
 * @param {string} [props.uid] ログインUID
 */
export default function MemberData(props) { 
  const navigate = useNavigate();
  // const [ Name,            setName            ] = useState(props.memberName)
  // const [ ImageUrl,        setImageUrl        ] = useState(props.member_url)
  // const [ Birthday,        setBirthday        ] = useState(props.birthday)
  // const [ SymptomsCardNum, setSymptomsCardNum ] = useState(props.symptomsCardNum)
  // const [ memberID,        setMemberID        ] = useState(props.memberID)
  // const [ familyID,        setFamilyID        ] = useState(props.familyID)
  // const [ uid,             setUid             ] = useState(props.uid)
  // console.log("MemberData.js Name:%s",props.memberName)
  // console.log("MemberData.js memberID:%s",props.memberID)
  // console.log("MemberData.js familyID:%s",props.fatemilyID)
  // console.log("MemberData.js uid:%s",props.uid)
  // console.log("MemberData.js member_url:%s",props.member_url)
  /**
   * メンバーカード本体クリック時に個人ホームへ遷移。
   */
  const handlerUserButtonClick = () =>{
    console.log("2 MemberData handlerUserButtonClick memberID["+props.memberID+"]")
    // this.props.history.push('/PersonalHome/' + props.memberID)
    navigate('/PersonalHome/' + props.memberID)
  }

  /**
   * 基本情報編集ボタン押下時に`FamilyRegist`へ遷移。
   */
  const handlerEditButtonClick = (memberID, familyID) =>{
    console.log("2 MemberData handlerEditButtonClick memberID["+props.memberID+"]")
    navigate('/familyregist', { state: {uid: props.uid, memberName: props.memberName, memberUrl: props.member_url, familyID: props.familyID, memberID: props.memberID, isEdit: true}})
  }

  return (
    <Card style={{display: 'flex', maxHeight:'80px', padding: 0, margin: 0}}>
      <CardMedia
        component="img"
        alt={props.memberName}
        image={props.member_url}
        title={props.memberName}
        style={{maxHeight:80, minHeight:50, maxWidth:80, minWidth:50, margin: 3}}
      />
      <CardActionArea onClick={()=>handlerUserButtonClick()}>
        <CardContent>
          <div className="text-left textTitle famikarColor">
            <Typography variant="subtitle1" className="border-bottom" component="div" align="left">
              <div>
                {props.memberName}
              </div>
            </Typography>
            <Typography component="div" align="left">
              受診一覧
              {/*生年月日: {props.birthday}<br />*/}
              {/*症状カード数： {SymptomsCardNum}枚<br />*/}
            </Typography>
          </div>
        </ CardContent>
      </CardActionArea>
      <CardActionArea color="primary" onClick={()=>{handlerEditButtonClick(props.memberID, props.familyID)}}
        style={{maxWidth:80, minWidth:80, margin: 3}}>
        <div>基本情報</div>
      </CardActionArea>
    </Card>
  )
}
